/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './unregisterPush.defs.js'
export { main as default } from './unregisterPush.defs.js'
